import { jsx as s } from "@emotion/react/jsx-runtime";
import { useLocation as c } from "react-router";
import { useSidebarContext as m } from "../../SidebarContext.js";
import { BaseMenuItem as d } from "../BaseMenu/BaseMenu.js";
import { StyledText as p } from "../BaseMenu/BaseMenu.styled.js";
const u = ({
  route: o
}) => {
  const {
    extended: e
  } = m(), {
    pathname: n
  } = c(), a = o.subRoutes?.some((t) => t?.notification && t.notification > 0), r = (t) => n.startsWith(t), i = o.subRoutes?.some((t) => typeof t.to == "string" && r(t.to));
  return /* @__PURE__ */ s(d, { route: o, isActive: !!i, hasNotification: a, children: /* @__PURE__ */ s(p, { variant: i ? "bodyMSemibold" : "bodyMRegular", as: "span", color: i ? "primary" : "secondary", extended: e, children: o.name }) });
};
export {
  u as ShowMoreButton
};
